import "core-js/stable";
import Vue from 'vue'
import App from './App.vue'
import VueBemCn from 'vue-bem-cn';
import VueGtm from '@gtm-support/vue2-gtm';

import router from './router';
import store from './vuex/store';

/* Plugins */
import './plugins/sentry';
import './plugins/vue-vee-validate';
import VueProjectConfig from './plugins/vue-project-config';
import VueUrlBuilder from './plugins/url-builder';
import vuetify from './plugins/vuetify';

/* Scripts */
import './scripts/firebase';
import './scripts/bbva';

/* Components */
import RtcIcoimage from '@/components/UI/rtc-icoimage';
import VTextFieldMoney from '@/components/inputs/v-text-field-money';

/* Filters */
import { formatMoney, formatNumber } from './filters/accounting';

/* CSS Deps */
import '@/sass/main.sass'


/* Init Config */

Vue.config.productionTip = false

/* Init Filters */
Vue.filter('formatMoney', formatMoney);
Vue.filter('formatNumber', formatNumber);

/* Init Plugins */
Vue.use(VueBemCn);
Vue.use(VueProjectConfig);
Vue.use(VueUrlBuilder);
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID,
  debug: process.env.NODE_ENV === 'development',
});

/* Global Components */
Vue.component('rtc-icoimage', RtcIcoimage);
Vue.component('v-text-field-money', VTextFieldMoney);

new Vue({
  render: h => h(App),
  store,
  vuetify,
  router
}).$mount('#app')
